import React from 'react'
import Header from '../component/Header';
import { Outlet } from 'react-router-dom';

export default function Project() {
  const navbarMenu = [
      { name: "Project", pageNavigate: "projectView" },
      { name: "Add Project", pageNavigate: "projectAdd" },
    ];
    return (
      <>
      <div className="screen_mainContainer">
        <Header navbarMenu={navbarMenu} />
        <Outlet />
      </div>
    </>
  )
}
